import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en/translations.json';
import nlTranslations from './locales/nl/translations.json';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: enTranslations,
    },
    nl: {
      translations: nlTranslations,
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

i18n.languages = ['en', 'nl'];

// index.html says `en`; keep it true when a page switches to Dutch, so
// screen readers and browser translation know what they are reading.
i18n.on('languageChanged', language => {
  document.documentElement.lang = language;
});

export default i18n;
